import { defaultsDeep } from "lodash";
import { CareseekerModule, DeepNullableObj } from "../types";
import { MockFn, createMock } from "./index";

const mockCareseekerModule: MockFn<
  Partial<DeepNullableObj<CareseekerModule>>
> = (args) =>
  defaultsDeep(
    args,
    createMock(
      "CareseekerModule",
      args,
      (): DeepNullableObj<CareseekerModule> => ({
        onboarding_email_link: "",
        onboarding_radius_km: 0,
        onboarding_requirements: "",
        prio_list_activation_target: 0,
        start_date: 0,
        status: 1,
      }),
    ),
  );

export default mockCareseekerModule;
